module.exports = __webpack_public_path__ + "static/media/linkedin.ebf09e47.svg";